import React, { useState, useEffect } from "react";
import api from "../../api/api";
import ToastMessage from "../../utils/mui/righttoptoast";
import { Skeleton } from "@mui/material";

const ProviderModal = ({ setScreen, selectedAppointment,fetchScheduleData ,selectedDate,closeAllModals}) => {
  const [activeButton, setActiveButton] = useState(null);  // Change activeButton to store provider name
  const [providerOptions, setProviderOptions] = useState([]);  // State to hold fetched provider options
  const [loading, setLoading] = useState(false);  // State for loading indicator
  const practiseid = window.getPracticeId();
  const [selectedProvider, setSelectedProvider] = useState('');  // Store the selected provider name
  const [selectedRoom, setSelectedRoom] = useState(null); 
      const [openToast, setOpenToast] = useState(false);
      const [toastMessage, setToastMessage] = useState('');
      const [toastSeverity, setToastSeverity] = useState('success');

  const handleToastClose = () => {
    setOpenToast(false)
};
  // Fetch provider data
  const fetchProviderData = async () => {
    setLoading(true);  // Start loading
    try {
      const response = await api.get(`/v1/${practiseid}/providers`);
      if (response.status === 200) {
        setProviderOptions(response.data);  // Set the provider options to state
 
      } else {
        setProviderOptions([]);
        
        // Clear if response is not successful
      }
    } catch (error) {
      console.error(error);
      setProviderOptions([]);  // In case of error, clear the options
   
    } finally {
      setLoading(false);  // Stop loading
    }
  };

  // Fetch provider data when component mounts
  useEffect(() => {
    fetchProviderData();
  }, []);

  console.log('Selected Appointment:', selectedAppointment);

  const SelectDate = new Date(selectedAppointment.startdate);
  const formattedDate =
    SelectDate.getFullYear() +
    "-" +
    (SelectDate.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    SelectDate.getDate().toString().padStart(2, "0");

  // Update provider status
  const UpdateProviderStatus = async ({ SelectedProvider }) => {
    try {
      const response = await api.put(
        `/v1/${practiseid}/appointments/visit-purpose/update`,
        {
          itemVal: [SelectedProvider],
          dtype: ["dtprovider"],
          app_id: [selectedAppointment.appointmentid],
          cid: [selectedAppointment.AID ?? selectedAppointment.id],
          searchdate: formattedDate,
        }
      );

      if (response.status === 200) {
        fetchScheduleData(selectedDate)
        setToastMessage("Provider Updated successfully");
        setToastSeverity('success');
        setOpenToast(true);
      } else {
        console.error("Update failed.");
        setToastMessage('Failed to Update Provider. Please try again.');
        setToastSeverity('info');
        setOpenToast(true);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      setToastMessage('Something Went Wrong');
      setToastSeverity('error');
      setOpenToast(true);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      {/* Popup Box */}
      <div className="relative flex flex-col gap-4 md:w-[30%] w-[80%] bg-white rounded-lg shadow-lg text-left">
        <div>
          <div className="w-full flex items-center justify-between mt-2 p-2 px-4">
            {/* Close Button */}
            <span className="ml-2 font-semibold text-[#1D2951] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
              Select Provider Here
            </span>
            <button
              className="text-gray-500 hover:text-gray-700 text-[30px]"
              onClick={()=>{
                setScreen(0)
              }}
            >
              &times;
            </button>
          </div>
          <div className="h-px bg-[#D0D5DD]"></div>
        </div>

        {/* Provider Buttons */}
        <div className="flex flex-wrap gap-4 p-4">
          {loading ? (
            <div>{
              // Display skeletons while loading
              Array.from({ length: 3 }).map((_, index) => (
                  <Skeleton
                      key={index}
                      variant="rectangular"
                      width={100}
                      height={35}
                      style={{ margin: '8px', borderRadius: '50px' }}
                  />
              ))
}</div> // Show loading message or spinner while fetching data
          ) : (
            providerOptions && Array.isArray(providerOptions) && providerOptions.length > 0 ? (
              providerOptions.map((provider, index) => (
                <button
                  key={index}
                  className={`rounded-full py-2 px-3 font-inter text-[12px] shadow-md border-[1.5px] border-gray-200 truncate ${
                    activeButton === provider.providername ? "bg-[#E17954] text-white" : "bg-[#F3F3F3] text-[#374151]"
                  }`}
                  onClick={() => {
                    setActiveButton(provider.providername);  // Set the selected provider's name
                    setSelectedProvider(provider.providername);  // Set the provider's name for update
                  }}
                >
                  {provider.providername} {/* Assuming provider has a 'providername' property */}
                </button>
              ))
            ) : (
              <div>No providers found.</div> // If no providers, show a message
            )
          )}
        </div>

        {/* Update Button */}
        <div className="w-full flex justify-center mt-2 py-4 border-t bg-[#F9FAFB] rounded">
          <button
            onClick={() => UpdateProviderStatus({ SelectedProvider: selectedProvider })}
            className="rounded py-2 px-4 w-[90%] font-inter transition duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] bg-[black] text-[#FFFFFF]"
          >
            Update
          </button>
        </div>
      </div>
      <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
    </div>
  );
};

export default ProviderModal;
